import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Alert,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { createMicroSite } from '../../store/actions/microSiteActions';

function CreateMicroSite({ open, onClose, accountId }) {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: '',
    subdomain: '',
    theme: 'default',
  });
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIsSubmitting(true);

    try {
      await dispatch(createMicroSite({
        accountId,
        siteData: formData
      })).unwrap();
      onClose();
    } catch (error) {
      setError(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create New Micro-Site</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              name="name"
              label="Site Name"
              value={formData.name}
              onChange={handleChange}
              required
              fullWidth
            />

            <TextField
              name="subdomain"
              label="Subdomain"
              value={formData.subdomain}
              onChange={handleChange}
              required
              fullWidth
              helperText="This will be your site's URL: subdomain.yourapp.com"
            />

            <FormControl fullWidth>
              <InputLabel>Theme</InputLabel>
              <Select
                name="theme"
                value={formData.theme}
                onChange={handleChange}
                label="Theme"
              >
                <MenuItem value="default">Default</MenuItem>
                <MenuItem value="modern">Modern</MenuItem>
                <MenuItem value="classic">Classic</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            type="submit"
            variant="contained"
            disabled={isSubmitting}
            startIcon={isSubmitting ? <CircularProgress size={20} /> : null}
          >
            Create Site
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default CreateMicroSite; 